import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { VStack, Box, Center, Spinner, Heading, AspectRatio, Button, Stack, Text, Image, Badge } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { BottomControlTest } from '@src/components/sco/CardCarousel/Controls/BottomControlTest';
import { usePerksContext } from '@src/components/sco/Perks/Layout/PerksContext';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { Benefit } from '@src/graphql-types.ts';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import React from 'react';
type PartnerDealsHeroProps = {
  keywords?: string;
  carouselProps?: CardCarouselProps;
};
export const PartnerDealsHero = props => {
  const $ = _c(12);
  const perksContext = usePerksContext();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    query {
      benefits(where: { categories_some: { slug: "featured" } }, orderBy: priority_DESC) {
        id
        name
        slug
        priority
        valueDescription
        redemptionUrl
        redemptionCode
        teaser
        tagline
        cardImage {
          id
          url
        }
        categories {
          id
          slug
          name
          icon {
            id
            url
          }
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  if ($[1] !== perksContext) {
    t1 = () => {
      perksContext.setBreadcrumbs([{
        title: "Perks",
        href: "/perks"
      }, {
        title: "Partners",
        href: "/perks/partners"
      }]);
      perksContext.setActiveSection("partners");
    };
    $[1] = perksContext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== query.data) {
    t2 = [query.data];
    $[3] = query.data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useUniversalEffect(t1, t2);
  if (query.loading || !query.data) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Center><Spinner /></Center>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== getBreakpointValue || $[7] !== props.carouselProps || $[8] !== query.data) {
    t3 = query.data && <CardCarousel fade={false} visibleCards={[1]} autoCycle={{
      delay: 5000,
      pauseOnHover: false
    }} controls={{
      top: false,
      bottom: BottomControlTest
    }} {...props.carouselProps}>{query.data?.benefits?.map(benefit => <Stack key={benefit.id} direction="row" gap={getBreakpointValue([10, 10, 10, 20])} height="full" justify="center" paddingBottom={5} paddingTop={getBreakpointValue([10, 10, 10, 20])} paddingX={getBreakpointValue([10, 10, 10, 20])} position="relative" background={getBreakpointValue([`linear-gradient(180deg, #1A1B2090, #1A1B20), url(${benefit.heroImage?.url}) center center/cover no-repeat`, `linear-gradient(180deg, #1A1B2090, #1A1B20), url(${benefit.heroImage?.url}) center center/cover no-repeat`, "transparent"])}><VStack align={getBreakpointValue(["center", "center", "flex-start"])} flex={1} gap={8} justify={getBreakpointValue(["center", "center", "center"])} zIndex={2}><Badge variant="label">Featured</Badge><VStack align={getBreakpointValue(["center", "center", "flex-start"])}><Heading as="h1" size={getBreakpointValue(["3xl", "3xl", "3xl", "4xl", "5xl"])} textAlign={getBreakpointValue(["center", "center", "left"])}>{benefit.name || "Loading..."}</Heading><Text fontSize={getBreakpointValue(["md", "lg", "xl"])} textAlign={getBreakpointValue(["center", "center", "left"])}>{benefit.tagline}</Text></VStack><Button asChild={true} size={getBreakpointValue(["md", "md", "md", "lg"])} variant="cta"><NextLink href={`/perks/partners/${benefit.slug}`}>View Details<ChevronRightIcon boxSize="1em" /></NextLink></Button></VStack><AspectRatio borderRadius="2xl" flex={2} hidden={getBreakpointValue([true, true, false])} overflow="hidden" ratio={1.7777777777777777}><Image src={benefit.cardImage?.url} /></AspectRatio></Stack>)}</CardCarousel>;
    $[6] = getBreakpointValue;
    $[7] = props.carouselProps;
    $[8] = query.data;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <Box bgColor="colorPalette.panel" position="relative" width="full"><Box marginX="auto" maxWidth="80em">{t3}</Box></Box>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};